/* eslint-disable */
/**
 * The path of the `PlaceOrderPage` to be consumed by a `<Router />`
 * @export
 */
export const PLACE_ORDER_PAGE_PATH = `/place-order`;

/**
 * Create a `href` that will resolve to `PlaceOrderPage`
 * @export
 * @returns {string} The `PLACE_ORDER_PAGE_PATH`
 */
export const createPlaceOrderPageLink = () => PLACE_ORDER_PAGE_PATH;

/**
 * Determine if the current page is the `PlaceOrderPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `PlaceOrderPage`
 */
export const isPlaceOrderPage = (match) => match.path === PLACE_ORDER_PAGE_PATH;
